export const MAX_BADGE = 99
